export default __webpack_public_path__ + "static/media/trackitCalories.2f4a3f23.jfif";